/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
  Heading,
  PrimaryText
} from "components/Text";
import {colors} from "nxtconstants";


const propTypes = {
  email: PropTypes.string.isRequired,
  submitSubscribe: PropTypes.func.isRequired,
  subscribeInputHandler: PropTypes.func.isRequired,
  success: PropTypes.bool.isRequired
};

const Subscribe = ({
  email,
  subscribeInputHandler,
  submitSubscribe,
  success
}) => {
  let subscribeInput = (
    <SubscribeInput className="subscribe-input-container">
      <input
        className="subscribe-input"
        name="email"
        placeholder="Enter email"
        type="email"
        value={email}
        onChange={subscribeInputHandler}
      />
      <input
        className="subscribe-submit"
        id="home-newsletter-blog-subscribe-button"
        type="submit"
        value="Subscribe"
        onClick={submitSubscribe}
      />
    </SubscribeInput>
  );

  if (success) {
    subscribeInput = (
      <Heading
        additionalStyles="align-self: center;text-align: center"
        color={colors.dodgerBlue}
        fontSize="2.5rem"
      >
        Thanks for subscribing.
      </Heading>
    );
  }

  return (
    <div className="subscribe-container">
      <Title>Subscribe</Title>
      <Description>
      Never miss an important update from Wealthy
      </Description>
      {subscribeInput}
    </div>
  );
};

const Title = styled.h3`
  font-family: DMSerif-Regular;
  font-size: 4.2rem;
  line-height: 1.4;
  color: #000000;
  font-weight: 100;
  text-align: center;

  @media (max-width: 768px) {
    width: 100%;
    font-size: 2.7rem;
  }

`;

const Description = styled.p`
  width: 40%;
  color: #7e7e7e;
  margin: 1.4rem auto 1.4rem;
  font-family: MavenPro;
  font-size: 2.4rem;
  line-height: 1.4;
  text-align: center;

  @media (max-width: 768px) {
    width: 100%;
    font-size: 1.8rem;
    margin: 2.7rem auto;
  }

`;

const SubscribeInput = styled.form`
text-align: center;
.subscribe-input {
  display: flex;
  margin: 0 auto;
  width: 40%;
  border: none;
  border-bottom: 1px solid #DDDDDD;
  padding: 2rem;
  color: #000000;
  font-size: 2.4rem;
  line-height: 1.4;
  font-family: MavenPro;
  text-align: center;

  ::placeholder {
    color: #000000;
  }

  @media (max-width: 768px) {
    width: 100%;
    font-size: 1.8rem;
  }
}
.subscribe-submit {
  display: block;
  margin: 0 auto;
  margin-top: 4rem;
  width: 23rem;
  height: 5.2rem;
  border-radius: 0.4rem;
  background-color: ${colors.primary};
  border: none;
  color: #fff;
  font-size: 1.6rem;
  font-weight: 600;
  font-family: MavenPro;
  cursor: pointer;
  transition: all 300ms cubic-bezier(0.46,0.03,0.52,0.96);
  }

  @media (max-width: 37.5em) {
    justify-self: start;

    .subscribe-input {
      width: 80%;
    }

    .subscribe-input,
    .subscribe-submit {
      height: 3.5rem;
    }
  }
`;

Subscribe.propTypes = propTypes;

export default Subscribe;
